import maintainRequest from "@/maintain/utils/maintainRequest";

const obj = {
  getDeviceByCode(code) {
    return maintainRequest.get(
      `/device/maintenanceMan/deviceQRCode/getDeviceByCode/${code}`
    );
  },
};
export default obj;
